module.exports = {
    "crude": {
        "search": "Buscar",
        "actions": "Comportamiento",
        "nextPage": "Siguiente página",
        "lastPage": "Pagina anterior",
        "back": "Atrás",
        "empty": "vacío",
        "edit": "editar",
        "create": "crear",
        "data": "registro",
        "view": "espectáculo",
        "delete": "Borrar",
        "save": "Ahorrar",
        "cancel": "Cancelar",
        "noContent": "No hay entradas disponibles. ",
        "resetFilter": "¡Restablece los filtros y mira más contenido!",
        "createOwnTextField": "Crea tu propio campo de texto",
        "textFieldName": "etiqueta de campo de texto",
        "textFieldValue": "Contenido",
        "insertTextFieldLabel": "¡Por favor ingrese el nombre del campo de texto!",
        "deleteTextField": "Eliminar campo de texto",
        "success": "Guardar fue exitoso",
        "invalidDataFields": "Los siguientes campos de datos no son válidos:  ",
        "entries": "entradas",
        "entry": "entrada",
        "tabDetail": "detalles",
        "entity": "entidad",
        "of": "de",
        "uploadNewFile": "Subir archivo",
        "upload": "subir",
        "confirm": "DE ACUERDO",
        "deleteFileQuestion": "¿Realmente deseas eliminar este archivo? ",
        "deleteFileQuestionTitle": "¡Peligro!",
        "deleteEntityQuestion": "¿Realmente desea eliminar esta entidad? ",
        "deleteEntityQuestionTitle": "¡Peligro!",
        "errorLargeFileUpload": "¡El archivo seleccionado es demasiado grande!",
        "useCroppedImage": "Usar cultivo",
        "useOriginalImage": "Usar imagen original",
        "available": "disponible",
        "searchColumn": "encontrar columna",
        "manageColumns": "Administrar columnas",
        "hideColumn": "ocultar columna",
        "pinToRight": "Fijar columna a la derecha",
        "pinToLeft": "Fijar columna a la izquierda",
        "sortAsc": "Orden ascendente",
        "sortDesc": "Orden descendiente",
        "hideAll": "ocultar todo",
        "showAll": "Mostrar todo",
        "preview": "avance",
        "title": "título",
        "description": "Descripción",
        "tooltip": "información sobre herramientas",
        "sort": "Ordenar por",
        "settings": "Ajustes",
        "incomingReference": "referencia",
        "language": "Idioma",
        "deleteTabQuestionTitle": "¡Peligro!",
        "deleteTabQuestion": "¿Realmente deseas eliminar esta pestaña? ",
        "deleteElementQuestionTitle": "¡Peligro!",
        "deleteElementQuestion": "¿Realmente deseas eliminar este elemento? ",
        "configurationEditorDescriptionStringLayout": "En esta columna se pueden seleccionar tres variantes para introducir el texto:",
        "configurationEditorDescriptionEnumLayout": "Se pueden seleccionar dos variantes para la selección de los elementos de esta columna:",
        "configurationEditorDescriptionBooleanLayout": "Se pueden seleccionar dos variantes para la selección de los elementos de esta columna:",
        "configurationEditorDescriptionForeignEntityLayout": "Se pueden seleccionar dos variantes para la selección de los elementos de esta columna:",
        "stringLayoutsingleline": "linea sola",
        "stringLayoutmultiline": "multilínea",
        "stringLayouteditor": "Editor de texto enriquecido",
        "enumLayoutradio": "boton de radio",
        "enumLayoutdropdown": "desplegable",
        "booleanLayoutcheckbox": "casilla de verificación",
        "booleanLayoutswitch": "interruptores",
        "foreignEntityLayoutpopUp": "surgir",
        "foreignEntityLayoutautocomplete": "desplegable",
        "foreignEntityLayoutlist": "lista",
        "formatTooltipbold": "Gordo",
        "formatTooltipitalic": "itálico",
        "formatTooltipunderline": "subrayada",
        "formatTooltipstrike": "Tachado",
        "formatTooltipclean": "formato claro",
        "formatTooltipcodeBlock": "código",
        "formatTooltipblockquote": "Cita",
        "formatTooltipcolor": "color de fuente",
        "formatTooltipbackground": "color de fondo",
        "formatTooltipfont": "fuente",
        "formatTooltipalign": "alineación",
        "formatTooltipheader": "tamaño de fuente",
        "formatTooltipsuper": "Sobrescrito",
        "formatTooltipsub": "subíndice",
        "formatTooltipordered": "Lista ordenada",
        "formatTooltipbullet": "Enumeración",
        "true": "Sí",
        "false": "No",
        "selectEntity": "seleccionar entidad",
        "filter": "filtrar",
        "useFilter": "Aplicar filtros",
        "defaultFilter": "restablecer filtro",
        "expand": "expandir",
        "hide": "esconder",
        "minimumSelectionError": "Se deben seleccionar al menos {{min}} entradas.",
        "maximumSelectionError": "Se puede seleccionar un máximo de {{max}} entradas."
    }
}
;